var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.16b4d31bcaace9b6b55567c182b4dab4.svg#v';
                    var viewUrl = 'sprites.16b4d31bcaace9b6b55567c182b4dab4.svg#view-v';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };